// Custom js
jQuery(document).ready(function ($) {

    console.log('Scrips plugins loaded..');
    const is_pre_certification_srd = ajax_is_pre_certification_srd;
    const site_url = window.location.origin;

    /**
     * Object configuration Uploadifive
     * @param {string} button_text 
     */
    function uploadifive_options(button_text){
        let options = {
            'uploadScript' : is_pre_certification_srd.ajaxurl + '?action=pre_certification_uploadify',
            'buttonText' : button_text,
            'multi' : false,
            'uploadLimit' : 5,
            'removeCompleted' : true,
            'formData' : {
                'nonce' : is_pre_certification_srd.nonce
            },
            'onUploadComplete' : function(file, data) {
                var obj_data = $.parseJSON( data );
                console.log(obj_data.success);
                
                if (obj_data.success) {
                    $(this).parent().parent().find('span.message').html(file.name);
                    $(this).parent().parent().find('input[type=hidden]').attr('value', obj_data.data);
                }else{
                    $(this).parent().parent().find('span.message, span.fileinfo').html(obj_data.data);
                }
                
            }
        }
        return options;
    }

    // Formulario médico
    $('#file_upload-formulario').uploadifive( 
        uploadifive_options('Formulario médico tratante')
    );

    // Formulario reportes médicos
    $('#file_upload-reportes').uploadifive(
        uploadifive_options('Reportes médicos actualizados')
    );

    // Formulario Itinerario 
    $('#file_upload-itinerario').uploadifive(
        uploadifive_options('Itinerario médico asignado por el hospital')
    );

    /**
     * Validate checkbox Servicios
    */
    $('[name="service_type[]"]').on('change', function () {
        let val = $(this).val();
        switch (val) {
            case 'Laboratorios' :
                if (this.checked) {
                    $('#laboratories_date').attr('required', true);
                    $('#laboratories_date').attr('disabled', false);
                }else{
                    $('#laboratories_date').attr('required', false);
                    $('#laboratories_date').attr('disabled', true);
                    $('#laboratories_date').val('');
                }
                break;
            case 'Consultas' :
                if (this.checked) {
                    $('#consultation_date').attr('required', true);
                    $('#consultation_date').attr('disabled', false);
                }else{
                    $('#consultation_date').attr('required', false);
                    $('#consultation_date').attr('disabled', true);
                    $('#consultation_date').val('');
                }
                break;
            case 'Estudios' :
                if (this.checked) {
                    $('#studies_date').attr('required', true);
                    $('#studies_date').attr('disabled', false);
                }else{
                    $('#studies_date').attr('required', false);
                    $('#studies_date').attr('disabled', true);
                    $('#studies_date').val('');
                }
                break;
            case 'Procedimientos' :
                if (this.checked) {
                    $('#process_date').attr('required', true);
                    $('#process_date').attr('disabled', false);
                }else{
                    $('#process_date').attr('required', false);
                    $('#process_date').attr('disabled', true);
                    $('#process_date').val('');
                }
                break;
        }
        $('#pre-certificacion-form').parsley().reset();
    });


    /**
     * 
     */
    $(document).on('submit','#pre-certificacion-form',function(event){
        event.preventDefault();
        $.ajax({
            url: is_pre_certification_srd.ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                action: 'save_data_form_db',
                nonce: is_pre_certification_srd.nonce,
                data: $(this).serialize()
            },
            beforeSend: function() {
                $('.loading-send-form').show();
            },
        })
        .done(function( response ) {
            if(response.success){
                Swal.fire({
                    title: '¡Solicitud exitosa!',
                    text: "Pronto revisaremos tu solicitud",
                    type: 'success',
                    confirmButtonText: 'Salir',
                    onClose: () => {
                        window.location.href = site_url + '/precertificacion-seguro-internacional/';
                    }
                }).then((result) => {
                    if (result.value) {
                        window.location.href = site_url + '/precertificacion-seguro-internacional/';
                    }
                });
            }else{
                $('#pre-certificacion-form .errors_form').html(response.data).show();
                $('html, body').animate({
                    scrollTop: $('#pre-certificacion-form .errors_form').position().top - 30
                }, 'slow');
                grecaptcha.reset();
            }
            $('.loading-send-form').hide();
        })
        .fail(function( response ) {
            console.log("error");
        });
    });

    console.log('todo el archivo cargado....');

});